import { useState, useMemo, useCallback } from 'react';

const useGroupGoodOption = ({ validator, subGoodList, goodOptionList, setGoodOptionList }) => {
  const [subGoodDetail, setSubGoodDetail] = useState(null);

  const subGoodItemList = useMemo(
    () =>
      subGoodList?.map((subGood, index) => ({
        key: subGood?.goodNumber,
        label: subGood?.goodName,
        itemNumber: subGood?.goodNumber,
        subGoodIndex: `상품 ${(index + 1).toString().padStart(2, '0')}`,
        disabled: subGood?.soldOut || subGood?.stopSale,
        ...subGood,
      })),
    [subGoodList]
  );

  const handleGroupDropDownOption = useCallback(
    (subGood) => {
      setSubGoodDetail(subGood);
      if (subGood.itemNodeList?.length === 0) {
        const subGoodItem = { ...subGood.itemList[0], itemName: subGood.goodName };
        if (validator(subGoodItem, subGood, goodOptionList)) {
          setGoodOptionList((prevOptions) => [
            ...prevOptions,
            { ...subGoodItem, subGoodIndex: subGood.subGoodIndex, count: 1 },
          ]);
        }
      }
    },
    [goodOptionList, setGoodOptionList, validator]
  );

  return { subGoodDetail, subGoodItemList, handleGroupDropDownOption };
};

export default useGroupGoodOption;
